/* =====================================================================
   Don Barato · home.js
   - <db-countdown data-end="EPOCH_SEGUNDOS">: cuenta regresiva real (oculta el reloj al terminar).
   - <db-tabs>: pestañas accesibles de «Productos con pestañas» (clic, flechas, Inicio/Fin y editor del tema).
   Lo cargan varias secciones: se define una sola vez.
   ===================================================================== */
(function () {
  const pad = (n) => String(n).padStart(2, '0');

  if (!customElements.get('db-countdown')) {
    customElements.define(
      'db-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.end = Number(this.dataset.end) * 1000;
          if (!this.end) {
            this.hidden = true;
            return;
          }
          this.els = {
            days: this.querySelector('[data-days]'),
            h: this.querySelector('[data-h]'),
            m: this.querySelector('[data-m]'),
            s: this.querySelector('[data-s]'),
          };
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
        tick() {
          const left = Math.floor((this.end - Date.now()) / 1000);
          if (left <= 0) {
            clearInterval(this.timer);
            this.hidden = true;
            return;
          }
          const days = Math.floor(left / 86400);
          const rest = left % 86400;
          if (this.els.days) {
            this.els.days.hidden = days === 0;
            const b = this.els.days.querySelector('b');
            if (b) b.textContent = days;
          }
          if (this.els.h) this.els.h.textContent = pad(Math.floor(rest / 3600));
          if (this.els.m) this.els.m.textContent = pad(Math.floor((rest % 3600) / 60));
          if (this.els.s) this.els.s.textContent = pad(rest % 60);
        }
      }
    );
  }

  if (!customElements.get('db-tabs')) {
    customElements.define(
      'db-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          if (!this.tabs.length) return;
          this.link = this.querySelector('[data-tabs-link]');
          this.titleEl = this.querySelector('[data-tabs-title]');
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (e) => this.onKey(e, i));
          });
          this.onBlockSelect = (e) => {
            const i = this.tabs.indexOf(e.target);
            if (i > -1) this.select(i);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }
        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }
        onKey(e, i) {
          const last = this.tabs.length - 1;
          let next = null;
          if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
          else if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = last;
          if (next === null) return;
          e.preventDefault();
          this.select(next, true);
        }
        select(index, focus) {
          this.tabs.forEach((tab, i) => {
            const on = i === index;
            tab.classList.toggle('is-on', on);
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.tabIndex = on ? 0 : -1;
            const panel = document.getElementById(tab.getAttribute('aria-controls'));
            if (!panel) return;
            const wasHidden = panel.hidden;
            panel.hidden = !on;
            if (on && wasHidden) {
              panel.classList.remove('is-entering');
              void panel.offsetWidth;
              panel.classList.add('is-entering');
            }
          });
          const tab = this.tabs[index];
          if (focus) tab.focus();
          if (this.link && tab.dataset.url) this.link.href = tab.dataset.url;
          if (this.titleEl && tab.dataset.title) this.titleEl.textContent = tab.dataset.title;
          tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
      }
    );
  }
})();
